import { Component, OnInit, RendererFactory2 } from "@angular/core";
import { FormArray } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { of, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { ModalComponent } from "src/app/components/modal/modal.component";
import { RegionScoping } from "src/app/services/interface";
import { District } from "src/app/types/country";
import { CountryStateService } from "src/app/_services/country.service";
import { ServiceFormService } from "../../service-form.service";

@Component({
  selector: "app-add-region",
  templateUrl: "./add-region.component.html",
  styleUrls: ["./add-region.component.scss"],
})
export class AddRegionComponent extends ModalComponent {
  private unsubscribe$ = new Subject();
  countries$ = this.countryService.countries$;
  districts$ = of([]);
  selectedCountry: string;
  selectedDistricts: Partial<District>[] = [];
  extra_cost_per_unit: number = 0
  constructor(
    renderFactory: RendererFactory2,
    private router: Router,
    private route: ActivatedRoute,
    private countryService: CountryStateService,
    private serviceFormService: ServiceFormService,
  ) {
    super(renderFactory);
  }

  onInit(): void {
    const { regionId } = this.route.snapshot.params;
    if (regionId && regionId != "add-region") {
      const values: RegionScoping[] = this.serviceFormService.regionScopingForm.value;
      const value = values.find((_, index) => index == parseInt(regionId));
      if (value) {
        this.selectedCountry = value.region;
        this.selectedDistricts = value.districts.map((district) => ({
          district,
        }));
        this.extra_cost_per_unit = value.extra_cost_per_unit
      }
    }
    this.countryService.getCountries().subscribe();
  }

  close() {
    this.show = false;
    setTimeout(
      () => this.router.navigate(["."], { relativeTo: this.route.parent }),
      100
    );
  }

  onDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onCountryChange(event) {
    this.districts$ = this.countries$.pipe(
      map((val) => {
        const country = val.find((country) => country.id == this.selectedCountry)
        if (country) {
          return country.districts || [];
        }
        return []
      })
    );
  }

  addScope() {
    const value: RegionScoping = {
      districts: this.selectedDistricts.map((district) => district.district),
      extra_cost_per_unit: this.extra_cost_per_unit,
      region: this.selectedCountry,
    }
    const form = this.serviceFormService.regionScopingForm
    const { regionId } = this.route.snapshot.params;
    if (regionId && regionId != "add-region") {
      const values: RegionScoping[] = this.serviceFormService.regionScopingForm.value;
      values[parseInt(regionId)] = value;
      this.serviceFormService.regionScopingForm.patchValue(values);

    }
    else {
      form.patchValue([value, ...form.value])
    }
    form.markAsDirty()
    this.close();
  }
}
